import React from 'react';

import Pill from 'components/Misc/Pill';
import Container from 'components/Misc/Container';
import { Title } from 'components/Misc/Typography';
import { Button } from 'components/Misc/Form';

import { useMaterialProfileStore } from 'store/material/useMaterialProfileStore';

const Course = ({ progress }) => {
	// Use material's profile store
	const [course, subject] = useMaterialProfileStore(state => [state.course, state.subject]);

	if ((!course.id || !subject.id) && !progress) {
		return (
			<div className="py-3 px-4 flex bg-red-500 text-white rounded-lg">
				Mācību materiāls nav piesaistīts mācību modlim!
			</div>
		);
	}

	return (
		<Container className="p-4 flex items-start">
			<div className="flex-1 flex items-center overflow-hidden">
				<Title
					title={course.title}
					subtitle={subject.title}
					className="flex-1 whitespace-nowrap text-ellipsis overflow-hidden"
				/>

				<div className="ml-3 flex space-x-2">
					<Pill
						name={`${course.hours}h`}
						theme="informative"
					/>

					<Button
						small
						square
						icon="link"
						to={`/courses/${course.id}`}
					/>
				</div>
			</div>
		</Container>
	);
};

export default Course;